<div class="modal fade" :id="modalComponentId" tabindex="-1" role="dialog" :aria-labelledby="modalComponentId + 'Label'" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" :id="modalComponentId + 'Label'">{{modalHeading}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onModalCloseClick">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p class="text-info">
                    NOTE: Ticked products are currently linked to the promotion. Unticked products are not linked to the promotion.
                    Unticking a product will unlink it from the promotion.
                </p>
                <data-table :headings="productHeadings" 
                            :data="products"
                            :pagingDetails="pagingDetails"
                            :hasNoPaging="false"
                            :stateChanged="false"
                            :hasActions="true"
                            :hasCustomActionComponent="true"
                            @pagingUpdated="onPagingUpdated"
                            @filterSearchClicked="onFilterSearchClicked">
                    <template #filter>
                        <div class="p-3">
                            <div class="input-group pb-4">
                                <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="searchQuery">
                                <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template #actionComponent="{ productId, isLinked }">
                        <input type="checkbox" :checked="isLinked" @change="onProductCheckOrUncheck(productId)">
                    </template>
                </data-table>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success" @click="onModalSaveClick" :disabled="formIsSaving">Link/Unlink</button>
                <button type="button" class="btn btn-secondary" @click="onModalCloseClick" :disabled="formIsSaving">Close</button>
            </div>
        </div>
    </div>
</div>